import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip'

const DefaultToolTip = ({ children, content, ...restProps }) => (
  <Tooltip title={content} arrow {...restProps}>
    <div>{children}</div>
  </Tooltip>
)

DefaultToolTip.propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node,
}

DefaultToolTip.defaultProps = {
  children: null,
}

export default DefaultToolTip
